import { PageIntro } from "@/components/site/PageIntro";
import { FAQSection } from "@/sections/FAQSection";
import { useSeo } from "@/components/site/Seo";

export default function FAQPage() {
  useSeo({
    title: "FAQ",
    description:
      "Frequently asked questions about Velora Intelligence — the AI-powered cryptocurrency intelligence platform for analysis, risk, monitoring and portfolio tracking.",
    path: "/faq",
  });
  return (
    <main data-testid="faq-page">
      <PageIntro
        label="FAQ"
        title="Questions, answered"
        desc="Everything you need to know about how Velora Intelligence works and what it does — and does not — do."
      />
      <FAQSection withHeader={false} />
    </main>
  );
}
